import(/* webpackMode: "eager" */ "/src/src/app/[variants]/(staitc-page)/accessibility-statement/pc.module.scss");
;
import(/* webpackMode: "eager" */ "/src/src/app/[variants]/(staitc-page)/accessibility-statement/wap.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
